const COMPOSER_DRAFT_KEY_PREFIX = "clerical.chat.composer-draft.v1:";

export function readComposerDraft(scope: string): string {
	if (typeof window === "undefined") return "";
	try {
		return window.localStorage.getItem(COMPOSER_DRAFT_KEY_PREFIX + scope) ?? "";
	} catch {
		return "";
	}
}

export function writeComposerDraft(scope: string, text: string): void {
	if (typeof window === "undefined") return;
	try {
		if (text.trim() === "") {
			window.localStorage.removeItem(COMPOSER_DRAFT_KEY_PREFIX + scope);
			return;
		}
		window.localStorage.setItem(COMPOSER_DRAFT_KEY_PREFIX + scope, text);
	} catch {
		return;
	}
}
